import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../lib/site";

export default function CtaSection({ heading = "Let’s make your numbers make sense.", body = "The fastest way to clear answers is a quick phone call. Call us and speak directly with the person who will handle your books, or send a note and we will get right back to you.", testId = "cta-section" }) {
  return (
    <section className="relative bg-olive" data-testid={testId}>
      <div className="container-shell relative z-10 py-20 lg:py-24">
        <div className="flex flex-col items-start gap-10 lg:flex-row lg:items-end lg:justify-between">
          <Reveal className="max-w-2xl">
            <p className="eyebrow !text-sage/70">Ready when you are</p>
            <h2 className="mt-5 text-balance font-serif text-4xl leading-[1.1] tracking-tight text-sage sm:text-5xl">{heading}</h2>
            <p className="mt-6 text-base leading-relaxed text-sage/80 sm:text-lg">{body}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <a href={BUSINESS.phoneHref} data-testid={`${testId}-book-button`} className="inline-flex items-center justify-center gap-2 self-start rounded-full bg-sage px-5 py-2.5 text-sm font-bold text-olive transition-colors duration-300 hover:bg-white">
              Let’s Chat <ArrowUpRight className="h-4 w-4" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
